import { getMyReferralID, getMyReferralStats } from '../../cred';
// import { checkDocument } from '../../customLib';

export const initRefStats = {
	INR_earnt: 0,
	USDT_earnt: 0,
	BTC_earnt: 0,
	count: 0,
	last20: [],
};

export const getRefStats = async () => {
	try {
		const { status, data } = await getMyReferralStats();

		if (status === 1) {
			return {
				refStats: {
					...data,
				},
			};
		}
	} catch (error) {
		console.log('getMyReferralStats', error);
	}

	return {};
};

export const getRefId = async () => {
	try {
		const { status, data } = await getMyReferralID();

		if (status === 1) {
			const referralID = data.split('.com/')[1];
			// if (checkDocument()) {
			// 	window.fcWidget.setExternalId(referralID);
			// }
			return {
				referralID,
				refLink: data,
			};
		}
	} catch (error) {
		console.log('refId', error);
	}

	return {};
};
